import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  url_root: string = '';

  public userGroup: string = '';

  public airports: any[] = [];

  chartOptions = {
    title: {
      display: true,
      text: 'Passenger Throughput at All US Airports',
      fontSize: 20,
      // padding: 30
    },
    legend: {
      position: 'bottom'
    },
    datasets: {
      line: {
        pointRadius: 0, // disable points for all line datasets
        hoverRadius: 10,
        hitRadius: 10,
        cubicInterpolationMode: 'monotone',
        spanGaps: false  // true to draw lines between points with no or null data
      }
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItem: any, data: any) {
          return tooltipItem[0].label;
        },
        labelColor: function(tooltipItem: any, chart: any) {
          return {
            borderColor: chart.legend.legendItems[tooltipItem.datasetIndex].strokeStyle,
            backgroundColor: chart.legend.legendItems[tooltipItem.datasetIndex].fillStyle
          };
        },
        label: function(tooltipItem: any, data: any) {
          let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          let year = data.datasets[tooltipItem.datasetIndex].label;
          return ' ' + year.toString() + ': ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        afterLabel: function(tooltipItem: any, data: any): string {
          let display = '';
          if (data.datasets) {
            let dataset = data.datasets[tooltipItem.datasetIndex];
            let value0: number = dataset.data[tooltipItem.index];
            for (let i = 0; i < data.datasets.length; i++) {
              if (i != tooltipItem.datasetIndex) {
                let value = data.datasets[i].data[tooltipItem.index];
                let label = data.datasets[i].label;
                let valueStr = 'null';
                if(value) {
                  valueStr = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  display += label + ': ' + valueStr;
                  let change = Math.round((value0 / value - 1) * 1000) / 10;
                  display += ' (' + change.toString() + '%)';
                  if (i < data.datasets.length - 1) display += '\n';
                }
              }
            }
          }
          return display;
        }
      }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Date',
          fontSize: 16
        },
        type: 'time'
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Passengers',
          fontSize: 16
        },
        ticks: {
          callback(value: any, index: any, values: any): string {
            let total = 0;
            for(let i = 0; i < values.length; i++) {
              total += values[i];
            }
            let average = 0;
            if (values.length > 0) average = total / values.length;
            if(average > 1e6) {
              if(average < 3 * 1e6) {
                return Math.round(value / 1e5) / 10 + 'M';
              } else {
                return Math.round(value / 1e6) + 'M';
              }
            } else {
              if(average > 1e3) {
                if (average < 3 * 1e3) {
                  return Math.round(value / 1e2) / 10 + 'K';
                } else {
                  return Math.round(value / 1e3) + 'K';
                }
              } else {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            }
          }
        }
      }]
    },
    plugins: {
      colorschemes: {
        // https://nagix.github.io/chartjs-plugin-colorschemes/colorchart.html
        scheme: 'tableau.Classic10'
        // scheme: 'tableau.ClassicGreenOrange6'
      },
      zoom: {
        pan: {
          enabled: false,
          mode: 'x'
        },
        zoom: {
          enabled: false,
          mode: 'x',
          speed: 0.01,
          sensitivity: 3
        }
      }
    }
  };

  //tableau.Classic10
  colors = ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"];

  // Get forecast color
  hexToRgbA(hex:string): any {
    let c: any;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length== 3){
        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.5)';
    }
    throw new Error('Bad Hex');
  }

  getColor(i: number): any {
    return this.hexToRgbA(this.colors[i%10]);
  }

  commaFormat(value: any): string {
    if(value == null) return ' ';
    if(isNaN(value)) {
      return value.toString();
    } else {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  // Show points when there are less than 10 data points. Otherwise, single day data won't display.
  dataPoints(chart: any, size: number): void {
    if(chart) {
      if (size <= 10) {
        chart.options.datasets.line.pointRadius = 5;
        chart.options.scales.xAxes[0].time = {unit: 'day'};
      } else {
        chart.options.datasets.line.pointRadius = 0;
        chart.options.scales.xAxes[0].time = {};
      }
      chart.reinit();
    }
  }

}

